import { Modal } from 'bootstrap';

//intercept anchor clicks and display third party modal
const offsiteModals = document.querySelectorAll('a[data-modal-type=offsite]');
const thirdPartyModalEl = document.getElementById("third-party-modal")
const thirdPartyAcceptButtonEl = document.getElementById("third-party-accept-button")





for (let i = 0; i < offsiteModals.length; i++) {
  offsiteModals[i].addEventListener("click", function (event) {
    event.preventDefault(); // Prevent default anchor tag behavior
    createOffsiteModal(window, offsiteModals[i].href); // Call the modal creation function
  });
}

// 3rd party modal
window.createOffsiteModal = function createOffsiteModal(window, link) {
  var thirdPartyModal = new Modal(document.getElementById("third-party-modal"));
  Modal.getInstance(thirdPartyModalEl).show();
  thirdPartyAcceptButtonEl.href = link;

  thirdPartyAcceptButtonEl.addEventListener("click", function () {
    thirdPartyModal.hide();
  });

}